import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dropboxauth',
  templateUrl: './dropboxauth.component.html',
  styleUrls: ['./dropboxauth.component.css']
})
export class DropboxauthComponent implements OnInit {

 
  copyButton: boolean = true;
  copiedButton: boolean = false;


  constructor() { }

  ngOnInit(): void {
  }



  requestData =`
  curl 'https://api.optimusdrive.ai/v1/dropbox/auth' \
  -H 'authorization: XXXX' \
  -H 'content-type: application/json' \
  --data-raw '{"code":"EDXC-1at0t0AAAAAAAAAmdpfS9SLo5lQy9TI","redirect_uri":"https://dashboard.optimusdrive.ai/settings"}' 

  `


  sucessData =`
  {
    "data": null,
    "message": "Code authenticated successfully"
  }
  `

  Error4x =`
  {
    "error": "unable to generate token",
    "message": "Unable to process the request"
  }
  `

  Error401x=`
  {
    "error": {},
    "message": "Unauthorized"
  }
  `

  copyToClipBoard(url: string) {
    var txtArea = document.createElement('textarea');
    txtArea.id = 'txt';
    txtArea.style.position = 'fixed';
    txtArea.style.top = '0';
    txtArea.style.left = '0';
    txtArea.style.opacity = '0';
    txtArea.value = url;
    document.body.appendChild(txtArea);
    txtArea.select();

    try {
      var successful = document.execCommand('copy');
      if (successful) {
       this.copyButton = false;
       this.copiedButton = true;
  // After a few seconds, reset the button states
      setTimeout(() => {
        this.copyButton = true;
        this.copiedButton = false;
      }, 1000);
      }
    } catch (err) {
    } finally {
      document.body.removeChild(txtArea);
    }
  }

  copyJsonToClipboard() {
    this.copyToClipBoard(this.requestData);
  }


}
